var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicyBenefitIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 60,
    viewBox: "0 0 84 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 60,
    rx: 29.4545,
    fill: "#FFF4D8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7153_14767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7739 34.3213L45.7739 34.3214C45.8067 35.2952 45.4571 36.2352 44.7679 36.9632C44.0446 37.7261 43.0371 38.174 41.9986 38.174C39.9218 38.174 38.2233 36.4385 38.2233 34.3065C38.2233 33.9315 37.9336 33.6315 37.5616 33.6315C37.1897 33.6315 36.9 33.9315 36.9 34.3065C36.9 36.947 38.8344 39.1438 41.3369 39.4778V41.425C41.3369 41.8 41.6266 42.1 41.9986 42.1C42.3705 42.1 42.6602 41.8 42.6602 41.425V39.4776C43.8183 39.3206 44.9062 38.775 45.722 37.9056C46.6499 36.9204 47.1429 35.6296 47.0971 34.2801L47.0971 34.2797C46.9824 31.2269 44.7141 29.972 42.7659 28.8945L42.754 28.8879C41.8848 28.4057 41.0903 27.9649 40.5087 27.4157C39.9294 26.8689 39.5655 26.2181 39.56 25.3132C39.5601 24.7216 39.8395 24.0674 40.307 23.5775C40.7845 23.0887 41.3772 22.826 41.9873 22.826C43.323 22.826 44.4259 23.9408 44.4259 25.325C44.4259 25.7 44.7156 26 45.0876 26C45.4595 26 45.7492 25.7 45.7492 25.325C45.7492 23.4437 44.4095 21.8689 42.6602 21.5491V19.575C42.6602 19.2 42.3705 18.9 41.9986 18.9C41.6266 18.9 41.3369 19.2 41.3369 19.575V21.5389C40.6155 21.6819 39.9316 22.054 39.3772 22.6216C38.6529 23.3631 38.2365 24.3423 38.2479 25.3141C38.2482 27.9338 40.2641 29.0405 42.1414 30.0702C44.0041 31.0988 45.6974 32.04 45.7739 34.3213Z",
    fill: "#0D4248",
    stroke: "#0D4248",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7153_14767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.389,
    height: 24,
    fill: "white",
    transform: "translate(31.8057 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyBenefitIcon2);
export default __webpack_public_path__ + "static/media/policy-benefit-icon2.7b08d1afc3d74d8280d1697ef5bfb307.svg";
export { ForwardRef as ReactComponent };